import type { NavigationGuardReturn } from 'vue-router';

import { useFlagStore } from '@/stores/flag';

export async function constellationProAccessGuard(): Promise<NavigationGuardReturn> {
  const flagStore = useFlagStore();

  await flagStore.waitForUserFlags;
  if (flagStore.ready && flagStore.flags.constellationPro) {
    return true;
  }

  return { path: '/not-found' };
}
